<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
.input-wdt {
  width: 100%;
}
.level-inner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.level-inner-wrap .select-level-drop {
  width: 70%;
  margin-right: 15px;
}
.create-category {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.create-category .input-wdt2 {
  width: 80%;
  margin-right: 15px;
}
.con-img-upload {
  background: #efebeb;
}
.ql-container.ql-snow {
  min-height: 150px;
}
.profile-edit .ql-editor {
  min-height: 150px;
}
.countDivder {
  margin: 30px 0 0;
}
.rqrd {
  color: #f00;
}

.profile-edit{display:flex;}
.profile-edit .unlayer-editor{width: 100%}
</style>
<template>
  <div id="page-edit-tab-account">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          Venue
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Name"
          v-model="data_local.Name"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Name')"
        >{{ errors.first('Name') }}</span>
      </div>
      <div class="vx-col md:w-6/12 w-full mt-2">
        <label>
          Address
          <span class="rqrd">*</span>
        </label>
        <textarea           
          rows="5" 
          class="inputx w-full"
          name="Address"
          v-model="data_local.Address"
          @keyup="getAdrresAutocomplete()"
          v-validate="'required'">            
        </textarea>
        <ul>
          <li v-for="(result, i) in searchResults" :key="i" @click="setAddress(result)">
            {{ result }}
          </li>
        </ul>
        <span
          class="text-danger text-sm"
          v-show="errors.has('Address')"
        >{{ errors.first('Address') }}</span>
      </div>
      
      <div class="vx-col md:w-1/1 w-full mt-4 mb-4">
        <label>Map</label>
        <div class="flex items-center flex-col sm:flex-row">
          <GmapMap 
            ref="mapRef" 
            :center="Coordinates"
            :zoom="15"
            :options="{
               zoomControl: true,
               mapTypeControl: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: true,
               disableDefaultUI: false
             }"
            map-type-id="terrain"
            style="width: 100%; height: 400px">
              <GmapMarker
                :position="Coordinates"
                :clickable="true"
                :draggable="true"
                 @drag="updateCoordinates"
              />
          </GmapMap>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>
          Latitude
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Latitude"
          v-model="Coordinates.lat"
          @keyup="onChangeLatLong()"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Latitude')"
        >{{ errors.first('Latitude') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>
          Longitude
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Longitude"
          v-model="Coordinates.lng"
          @keyup="onChangeLatLong()"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Longitude')"
        >{{ errors.first('Longitude') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          Zip / Post Code
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="ZipCode"
          v-model="data_local.ZipCode"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('ZipCode')"
        >{{ errors.first('ZipCode') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          City
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="City"
          v-model="data_local.City"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('City')"
        >{{ errors.first('City') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          Country
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Country"
          v-model="data_local.CountryName"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Country')"
        >{{ errors.first('Country') }}</span>
      </div>
      <div class="vx-col md:w-1/4 w-full mt-2">
        <label>Select</label>
        <vs-checkbox class="inputx w-full" v-model="data_local.IsPrimary">Primary Venue</vs-checkbox>
      </div>
      <div class="vx-col md:w-1/4 w-full mt-2">
        <label>Tooltip State</label>
        <vs-radio class="inputx w-full" v-model="data_local.TooltipStateIsOpen" vs-name="TooltipStateIsOpen" vs-value="true">Open</vs-radio>
        <vs-radio class="inputx w-full" v-model="data_local.TooltipStateIsOpen" vs-name="TooltipStateIsOpen" vs-value="false">Close</vs-radio>
      </div>
      <div class="vx-col md:w-1/4 w-full mt-2">
        <label>Pin Color</label>
        <vs-input type="color" class="w-10 h-10" width="10" height="10" v-model="data_local.PinColor" />
      </div>

    </div>

    

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class=" mt-2" @click="$router.push('/event/venues')">Back To List</vs-button>
          <vs-button
            class="ml-auto mt-2"
            @click="before_save"
            :disabled="!validateForm"
          >Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import * as VueGoogleMaps from 'vue2-google-maps'
//import VueCryptojs from 'vue-cryptojs'

import ls from "@/common/localStorage"
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
var vm;
import con from '@/firebase/firebaseInit.ts'
var gmapApiKey = con.googleMapApiKey;

Vue.use(VueGoogleMaps, {
  load: {
    key: gmapApiKey,
    libraries: 'places',
    installComponents: true
  }
});

//Vue.use(VueCryptojs);

export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      Coordinates: {lat:this.data.Latitude , lng:this.data.Longitude},
      searchResults: [],
      service: null
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  watch: {
    
  },
  methods: {
    onChangeLatLong(){
      if(this.Coordinates.lat && this.Coordinates.lng){
        this.fetchAddressByCoordinates();
        this.fetchCoordinatesByAddress()
      }
    },
    updateCoordinates(location) {
        this.Coordinates = {
            lat: location.latLng.lat(),
            lng: location.latLng.lng(),
        };
        this.fetchAddressByCoordinates();
    },
    fetchAddressByCoordinates() {
      let data = {
        coordinates: this.Coordinates,
        gmapApiKey: gmapApiKey
      }
      this.$store.dispatch("venueManagement/fetchAddressByCoordinates", data).then(res => {
          this.data_local.Address = res.data.formatted_address;
          this.data_local.CountryName = this.getDataFromGeoAddressComponents(res.data.address_components, 'country');
          this.data_local.City = this.getDataFromGeoAddressComponents(res.data.address_components, 'locality');
          this.data_local.ZipCode = this.getDataFromGeoAddressComponents(res.data.address_components, 'postal_code');
      })
    },
    fetchCoordinatesByAddress() {
      let data = {
        Address: this.data_local.Address,
        gmapApiKey: gmapApiKey
      }
      this.$store.dispatch("venueManagement/fetchCoordinatesByAddress", data).then(res => {
          this.Coordinates = res.data.geometry.location;
          this.data_local.CountryName = this.getDataFromGeoAddressComponents(res.data.address_components, 'country');
          this.data_local.City = this.getDataFromGeoAddressComponents(res.data.address_components, 'locality');
          this.data_local.ZipCode = this.getDataFromGeoAddressComponents(res.data.address_components, 'postal_code');
      })
    },
    getDataFromGeoAddressComponents(addrComponents, checkField){
      for (var i = 0; i < addrComponents.length; i++) {
          if (addrComponents[i].types[0] == checkField) {
              return addrComponents[i].long_name;
          }
          if (addrComponents[i].types.length == 2) {
              if (addrComponents[i].types[0] == "political") {
                  return addrComponents[i].long_name;
              }
          }
      }
      return null;
    },
    setAddress(result){
      this.data_local.Address=result;
      this.searchResults=[];
      this.fetchCoordinatesByAddress()
    },
    getAdrresAutocomplete () {
      if (this.data_local.Address) {
        this.service.getPlacePredictions({
          input: this.data_local.Address,
          //types: ['(cities)']
        }, this.displaySuggestions)
      }
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction.description) 
    },
    getAddressData: function (addressData, placeResultData, id) {
        this.data_local.Address = addressData;
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes() {
      /* eslint-disable */
      if (!this.validateForm) return;

      this.$vs.loading();
      const Id = this.$route.params.id;
      this.data_local.Latitude = this.Coordinates.lat;
      this.data_local.Longitude = this.Coordinates.lng;
      if (Id) {
          this.$store
            .dispatch("venueManagement/updateVenue", {
              id: Id,
              data: this.data_local,
            })
            .then((res) => {
              //alert(res.message)
              this.$vs.notify({
                color: "success",
                position: "top-center",
                //title: "Page",
                text: "Data updated successfully.",
              });
              this.$vs.loading.close();
            })
      } else {
          this.$store
            .dispatch("venueManagement/addVenue", { data: this.data_local })
            .then((res) => {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                //title: "Page",
                text: "Data added successfully.",
              });
              this.$vs.loading.close();
              if (res.status == 200) {
                this.$router.push('/event/venues');
              }
            })
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    
  },
  mounted(){
    vm = this;    
     this.$refs.mapRef.$mapPromise.then((map) => {
      this.MapsInit()
    })    
    /*var data = "clientid=C1594146761016";
    var key  = this.CryptoJS.enc.Latin1.parse('1234567812345678');
    var iv   = this.CryptoJS.enc.Latin1.parse('1234567812345678');  
    var encrypted = this.CryptoJS.AES.encrypt(
      data,
      key,
      {iv:iv,mode:this.CryptoJS.mode.CBC,padding:this.CryptoJS.pad.ZeroPadding
    });
    console.log('encrypted: ' + encrypted) ;
    var decrypted = this.CryptoJS.AES.decrypt(encrypted,key,{iv:iv,padding:this.CryptoJS.pad.ZeroPadding});
    console.log('decrypted: '+decrypted.toString(this.CryptoJS.enc.Utf8));*/
  },
  created() {
    
  },
};
</script>
